/* eslint-disable no-self-assign */

const week = {
    0: "星期日",
    1: "星期一",
    2: "星期二",
    3: "星期三",
    4: "星期四",
    5: "星期五",
    6: "星期六"
}
export class Utils{
    /**
     * 获取当前系统完整时间
     * @param {*} reference 引入的html模板容器
     */
     static getSystemFullTime = (dayParam) => {
        let time = dayParam ? new Date(dayParam) : new Date();
        let systemTime = {
            time: "",
            date: "",
            week: ""
        };
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        month < 10 ? month = '0' + month : month = month;
        let day = time.getDate()
        day < 10 ? day = '0' + day : day = day;
        let hours = time.getHours();
        hours < 10 ? hours = '0' + hours : hours = hours;
        let minutes = time.getMinutes();
        minutes < 10 ? minutes = '0' + minutes : minutes = minutes;
        let seconds = time.getSeconds();
        const weekday = week[time.getDay()];
        seconds < 10 ? seconds = '0' + seconds : seconds = seconds;
        systemTime.time = hours + ':' + minutes;
        systemTime.date = year + '-' + month + '-' + day;
        systemTime.week = weekday;
        return systemTime;
    }

    /**
     * 初始processLine数据
     */
    static initProcessLine = (data, type, keys, unit) => {
        let result = {
            process: [],
            title: []
        };
        if(data.length === 0){
            return result;
        }
        let offset = 1;
        data = data.map(elem => {
            switch (type) {
                case 'date':
                    //转成毫秒
                    elem.start = new Date(elem[keys.start]).getTime();
                    elem.end = new Date(elem[keys.end]).getTime();
                    offset = 24 * 60 * 60 * 1000;
                    break;
                case 'time':
                    //转成分钟
                    elem.start = elem[keys.start].split(':')[0] * 60 + Math.round(elem[keys.start].split(':')[1]);
                    elem.end = elem[keys.end].split(':')[0] * 60 + Math.round(elem[keys.end].split(':')[1]);
                    break;
                default:
                    elem.start = Math.round(elem[keys.start]);
                    elem.end = Math.round(elem[keys.end]);
                    break;
            }
            return elem
        });
        //总数
        let totalProcess = data[data.length - 1].end - data[0].start;
        data.forEach((elem, i) => {
            result.process.push({
                name: elem[keys.start] + (unit ? unit.process : ''),
                position: i === 0 ? '0' : (elem.start - data[0].start) * 100 / totalProcess
            });
            if (i === data.length - 1) {
                result.process.push({
                    name: elem[keys.end] + (unit ? unit.process : ''),
                    position: 100
                });
                result.title.push({
                    name: (keys.title ? elem[keys.title] : '') + (unit ? unit.title : ''),
                    position: (elem.end - elem.start) * 100 / totalProcess
                })
            } else {
                result.title.push({
                    name: (keys.title ? elem[keys.title] : '') + (unit ? unit.title : ''),
                    position: (elem.end + offset - elem.start) * 100 / totalProcess
                })
            }
        });
        let pos = 0;
        let cache;
        result.title.forEach(elem => {
            cache = elem.position;
            elem.position = pos + elem.position / 2;
            pos += cache;
        });
        return result
    };

    // 序列化表格结构为列表结构
    static serializeTableToList = (data, columns) => {
        let result = [];
        const keyList = columns.map(item => { return item.value });
        columns.forEach(item => {
            result.push({
                name: item.name,
                value: ""
            });
        });
        for(let key in data){
            keyList.forEach((keyItem, index) => {
                if(key === keyItem){
                    result[index].value = data[key];
                }
            })
        }
        return result;
    }

    // 将秒数格式化为hh:mm:ss结构
    static formatSeconds(seconds){
        if(seconds){
            let second = parseInt(seconds);
            let hours = Math.floor(second / 3600);
            second = second - hours * 3600;
            let minutes = Math.floor(second / 60);
            second = second - minutes * 60;
            return ("0" + hours).slice(-2) + ":" + ("0" + minutes).slice(-2) + ":" + ("0" + second).slice(-2);
        } else{
            return "00:00:00";
        }
    }
    static debounce(fn, duration){
        let timer = null;
        return function(){
            if(timer != null){
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                fn.call(this);
                timer = null;
            }, duration);
    
        }
    }
}

